import React from 'react'
import { ProjectIcon } from '../../lib/projectIcons'
import { FormLabel } from '../FormLabel'
import { cn } from '../../lib/utils'
import { FieldProps } from 'formik'

interface Props extends FieldProps {
  icons: ProjectIcon[]
  label?: string
}

export const IconPickerInput: React.FC<Props> = (props) => {
  const value = props.field.value

  return (
    <div className="flex flex-col gap-1">
      {props.label && <FormLabel>{props.label}</FormLabel>}
      <div className="flex flex-wrap items-center gap-2">
        {props.icons.map((icon) => {
          const isActive = value === icon.iconName

          return (
            <div
              key={icon.iconName}
              onClick={() => props.form.setFieldValue(props.field.name, icon.iconName)}
              className={cn(
                'bg-gray-100 rounded-md shadow-sm p-1 text-gray-600 transition-all',
                'hover:bg-blue-700 hover:text-white cursor-pointer hover:scale-110',
                isActive && 'bg-blue-700 text-white',
              )}
            >
              <icon.icon size={24} />
            </div>
          )
        })}
      </div>
    </div>
  )
}
